import { Component, OnInit } from '@angular/core';
import { PersquisaService } from '../service/persquisa.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pesquisa',
  templateUrl: './pesquisa.component.html',
  styleUrls: ['./pesquisa.component.css']
})
export class PesquisaComponent implements OnInit {

  constructor(
    private pesquisaService: PersquisaService,
  ) { }

  pesquisas: any;

  ngOnInit(): void {
    this.buscarPesquisas();
  }

  buscarPesquisas(){
    this.pesquisaService.listarPesquisas().subscribe(resp => {
      this.pesquisas = resp
    })
  }

  desativarPesquisa(idPesquisa: any){
    Swal.fire({
      title: 'Desativar pesquisa?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.pesquisaService.desativarPesquisas(idPesquisa).subscribe(resp => {})
        this.buscarPesquisas();
      }
    })
  }
}
